import React, { useEffect, useState } from "react";
import { Edit, Trash } from "@rsuite/icons";
import {
  Modal,
  Container,
  Content,
  Row,
  Col,
  Loader,
  Button,
  IconButton,
} from "rsuite";
import "./Users.css";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { useSelector } from "react-redux";
import {
  onOffArr,
  yesNoObj,
  httpStatusArr,
  messageTypeArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { displayField } from "../../../utils/helpers";
const ViewAddressModal = ({
  status,
  toggle,
  setIsEditAddress,
  isAddressChanged,
  setEditAddObj,
}: {
  status: boolean;
  toggle: any;
  setIsEditAddress: any;
  isAddressChanged: boolean;
  setEditAddObj: any;
}) => {
  const { t } = useTranslation();
  const userId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [userInfo, setUserInfo] = useState<any>({});
  const [addresses, setAddresses] = useState([]);
  const [isViewAdd, setIsViewAdd] = useState(0);
  const [isConfirmationModal, confirmationModal] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState("");

  const [deleteAddId, setDeleteAddId] = useState<any>(null);
  const [defaultAddressId, setDefaultAddressId] = useState(null);

  const getAddresses = async () => {
    try {
      setLoader(true);
      const res: any = await UserServices.viewUser(userId);

      if (res?.data?.data) {
        setUserInfo(res?.data?.data);
      }
      if (res?.data?.data?.addresses?.length) {
        setAddresses(res?.data?.data?.addresses);
        res?.data?.data?.addresses.map((add: any, index: number) => {
          if (add?.is_primary_address === onOffArr.on) {
            setIsViewAdd(index);
          }
        });
      }
      setLoader(false);
    } catch (error: any) {
      console.log(error);

      setLoader(false);
    }
  };

  const deleteAddress = async (id: number) => {
    try {
      setLoader(true);
      const res: any = await UserServices.deleteAddress(id);
      if (res?.data.status === httpStatusArr.ok && res?.data?.message) {
        getAddresses();
        confirmationModal(false);
        UtilityServices.showToaster({
          message: res?.data?.message,
        });
      }
    } catch (error: any) {
      setLoader(false);
      confirmationModal(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  };

  const makeDefaultAddress = async (id: number) => {
    try {
      let payload = { is_primary_address: onOffArr.on };
      setLoader(true);
      const res: any = await UserServices.updateAddress(id, payload);
      if (res?.data.status === httpStatusArr.ok && res?.data?.message) {
        getAddresses();
        confirmationModal(false);
        UtilityServices.showToaster({
          message: res?.data?.message,
        });
      }
    } catch (error: any) {
      setLoader(false);
      confirmationModal(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  };

  useEffect(() => {
    getAddresses();
  }, []);

  useEffect(() => {
    console.log(isAddressChanged);
    getAddresses();
  }, [isAddressChanged]);

  return (
    <div className="modal-container">
      <Modal
        open={status}
        backdrop={true}
        onClose={(e: any) => {
          toggle("");
          setEditAddObj({});
        }}
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            backdrop
            content={t("LOADING")}
            vertical
          />
        )}
        <Modal.Header>
          <h4>
            {" "}
            {displayField(`${userInfo?.name}`)}'s {t("ADDRESS")}
            {addresses.length > 1 && "es"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {addresses.length ? (
              <Content>
                {addresses.map((add: any, index) => {
                  return (
                    <div key={index}>
                      <div
                        className="add-heading"
                        style={{
                          background:
                            add?.is_primary_address === onOffArr.on
                              ? "#4CAF50"
                              : "#e5e1e1",
                          color:
                            add?.is_primary_address === onOffArr.on
                              ? "#ffffff"
                              : "",
                        }}
                        onClick={(e: any) => {
                          setIsViewAdd(index);
                        }}
                      >
                        {t("ADDRESS")} {index + 1}
                        {add?.is_primary_address === onOffArr.on
                          ? `" - (${t("PRIMARY_ADDRESS")})"`
                          : ""}
                      </div>
                      {isViewAdd === index ? (
                        <div className="address">
                          <Row>
                            <Col className="address-col">
                              {t("HOUSE_NO")} :
                              <label>{displayField(`${add?.house_no}`)}</label>
                            </Col>
                            <Col className="address-col">
                              {t("LANDMARK")} :
                              <label>{displayField(`${add?.landmark}`)}</label>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="address-col">
                              {t("BUILDING")} :
                              <label>
                                {displayField(`${add?.building_name}`)}
                              </label>
                            </Col>
                            <Col className="address-col">
                              {t("AREA")} :
                              <label>{displayField(`${add?.area_name}`)}</label>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="address-col">
                              {t("MOBILE")} :
                              <label>{displayField(`${add?.mobile}`)}</label>
                            </Col>
                            <Col className="address-col">
                              {t("IS_DEFAULT")} {t("ADDRESS")}:
                              <label>
                                {add?.is_primary_address === onOffArr.on
                                  ? yesNoObj.yes
                                  : yesNoObj.no}
                              </label>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="address-col">
                              {t("CITY")} :
                              <label>
                                {displayField(`${add?.city?.city_name}`)}
                              </label>
                            </Col>
                            <Col className="address-col">
                              {t("STATE")} :
                              <label>
                                {displayField(`${add?.state?.state_name}`)}
                              </label>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="address-col">
                              {t("COUNTRY")} :
                              <label>
                                {displayField(`${add?.country?.country_name}`)}
                              </label>
                            </Col>
                            <Col className="address-col">
                              {t("PINCODE")} :
                              <label>{displayField(`${add?.pincode}`)}</label>
                            </Col>
                          </Row>

                          <Row className="bottom-buttons">
                            <IconButton
                              title={t("EDIT")}
                              size="md"
                              icon={<Edit />}
                              onClick={(e: any) => {
                                toggle("add-address");
                                setIsEditAddress(true);
                                setEditAddObj(add);
                              }}
                            >
                              {t("UPDATE")}
                            </IconButton>
                            <IconButton
                              icon={<Trash />}
                              title={t("DELETE")}
                              size="md"
                              onClick={(e: any) => {
                                setDeleteAddId(add?.id);
                                setDefaultAddressId(null);
                                confirmationModal(true);
                                setConfirmationMsg(
                                  t("CONFIRM_ACTION", {
                                    action: t("DELETE").toLowerCase(),
                                    entity: t("ADDRESS").toLowerCase(),
                                  })
                                );
                              }}
                            >
                              Delete
                            </IconButton>
                            <Button
                              style={{ marginLeft: "10px" }}
                              onClick={(e: any) => {
                                setDefaultAddressId(add?.id);
                                setDeleteAddId(null);
                                confirmationModal(true);
                                setConfirmationMsg(
                                  t("CONFIRM_ACTION", {
                                    action: t("MARK_PRIMARY").toLowerCase(),
                                    entity: t("ADDRESS").toLowerCase(),
                                  })
                                );
                              }}
                            >
                              {t("MARK_PRIMARY")}
                            </Button>
                          </Row>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </Content>
            ) : null}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <AlertModal
            open={isConfirmationModal}
            handleClose={(e: any) => {
              if (e === true) {
                confirmationModal(false);
                if (deleteAddId) {
                  deleteAddress(deleteAddId);
                }
                if (defaultAddressId) {
                  makeDefaultAddress(defaultAddressId);
                }
              } else {
                confirmationModal(false);
              }
            }}
            displayText={confirmationMsg}
            modalTitle={t("CONFIRM_ACTION_TITLE", {
              action: "",
            })}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewAddressModal;
